{
  "productDetails": {
    "id": "ID",
    "quantity": "Menge",
    "productDetails": "Product Details",
    "specification": "Specs",
    "reviews": "Reviews",
    "shipping": "Shipping",
    "share": "Share",
    "showReviews": "Show reviews",
    "noReviews": "No reviews yet",
    "uigArticleNumber": "RF-Artikelnummer",
    "supplierArticleNumber": "Hersteller-Art.Nr.",
    "uvpPrice": "Hersteller UVP",
    "priceMargin": "Spanne",
    "ekPrice": "EK",
    "bestPrice": "Bestpreis",
    "discountName": "Bonusart",
    "discountMessage": "Die Bestpreisermittlung setzt sich folgenderma\u00DFen zusammen",
    "rfuvpPrice": "RINGFOTO UVP"
  },
  "productList": {
    "filterBy": {
      "label": "Filter by",
      "action": "Filter by"
    },
    "appliedFilter": "Ausgewählte Filter:",
    "showLess": "Weniger...",
    "showMore": "Mehr...",
    "sortByRelevance": "Sort by Relevance",
    "backToTopBtn": "ZURÜCK ZUM ANFANG",
    "showMoreBtn": "SHOW MORE"
  },
  "productFacetNavigation": {
    "filterBy": {
      "label": "Filter by",
      "action": "Filter by"
    },
    "appliedFilter": "Applied filter:",
    "showLess": "Show less...",
    "showMore": "Show more...",
    "sortByRelevance": "Sort by Relevance"
  },
  "productSummary": {
    "id": "ID",
    "showReviews": "Show reviews",
    "share": "Share"
  },
  "productReview": {
    "overallRating": "Overall Rating",
    "reviewTitle": "Review Title",
    "writeYourComments": "Write your comments",
    "rating": "Rating",
    "reviewerName": "Reviewer name (optional)",
    "writeReview": "Write a Review",
    "more": "More",
    "less": "Less",
    "thankYouForReview": "Thank you for the review! Note that reviews may require review before appearing here."
  },
  "addToCart": {
    "itemsAddedToYourCart": "Artikel zu Ihrem Warenkorb hinzugefügt",
    "error": "Dieser Artikel kann leider nicht bestellt werden und wird daher nicht in den Warenkorb übernommen.",
    "itemsIncrementedInYourCart": "Dieser Artikel war bereits in Ihrem Einkaufswagen. Die Menge wurde aktualisiert.",
    "items": "Artikel",
    "updatingCart": "Warenkorb wird aktualisiert...",
    "addToCart": "In Warenkorb",
    "viewCart": "Warenkorb",
    "proceedToCheckout": "Bestellen",
    "quantity": "Menge",
    "outOfStock": "Out of stock",
    "inStock": "In stock",
    "selectStyleAndSize": "Select style and size to check stock",
    "removeFromCart": "Remove Product from Cart",
    "closeModal": "Close Modal"
  },
  "TabPanelContainer": {
    "tabs": {
      "ProductDetailsTabComponent": "Produkt Details",
      "ProductSpecsTabComponent": "Technische Details",
      "ProductReviewsTabComponent": "Reviews",
      "deliveryTab": "Shipping",
      "ProductDownloadsTabComponent": "Download",
      "ProductVideoTabComponent": "Video-Link",
      "ProductPriceSearchTabComponent": "Preissuchmaschinen",
      "ProductNaturalRabattTabComponent": "Naturalrabatt",
      "ProductReferencesTabComponent": "Zubehör",
      "ProductSetsTabComponent": "Set"
    }
  },
  "variant": {
    "style": "Style",
    "selectedStyle": "Selected style",
    "size": "Size",
    "color": "Color",
    "sizeGuideLabel": "Style guide"
  },
  "addToWishList": {
    "add": "Merken",
    "remove": "Merken",
    "anonymous": "Merken (Anmelden)"
  },
  "stockNotification": {
    "notifyMe": "NOTIFY ME",
    "stopNotify": "STOP NOTIFICATION",
    "getNotify": "Get notified when this product is available.",
    "getNotifySuffix": "to get notified when this product is available.",
    "activateChannelsPrefix": "To be notified you need to activate the ",
    "channelsLink": "Notification Channels",
    "activateChannelsSuffix": ".",
    "notified": "You will be notified when this product is back in stock.",
    "getNotified": "Get notified when this product is back in stock.",
    "unsubscribeSuccess": "You will not receive back-in-stock notification for this product.",
    "subscriptionDialog": {
      "header": "Out of stock subscription",
      "notifiedPrefix": "You will be notified on:",
      "notifiedSuffix": "as soons as this product is back in stock.",
      "manageChannelsPrefix": "Manage your prefered notification channels at the ",
      "manageChannelsLink": "Notification Preference",
      "manageChannelsSuffix": " page.",
      "manageSubscriptionsPrefix": "You can manage your subscriptions at ",
      "manageSubscriptionsLink": "My Interests",
      "manageSubscriptionsSuffix": " page.",
      "okBtn": "OK",
      "subscribing": "Subscribing you to Out of Stock notifications for this product"
    }
  }
}
